import {
    ADD_TO_MONITORING_LIST,
    CLEAR_MONITORING_FOR_SIP,
    GET_AUDIO_URL, GET_MONITORING_QUEUE, GET_NEW_MONITORING_QUEUE,
    HIDE_LOADER,
    MONITORING_RELOAD_TOGGLE,
    SET_CURRENT_MONITORING_PAGE, SET_CURRENT_MONITORING_QUEUE_PAGE, SET_CURRENT_MONITORING_QUEUE_SIZE,
    SET_CURRENT_MONITORING_SIZE,
    SET_FIRST_PAGE,
    SET_MONITORING_FILTER, SET_SPEAKING_AUDIO,
    SHOW_EXPORT_LOADING,
    SHOW_LOADER, SHOW_MONITORING_QUEUE_LOADER, UPDATE_MONITORING_FILTER, SET_MONITORING_UI_FILTERS,
    UPDATE_SORT_FIELDS, SET_QUEUE_MONITOR_STATS, REMOVE_FROM_MONITORING_QUEUE
} from "../types/typesMonitoringList";
import {HIDE_ERROR, SET_AUDIO_UNAVAILABLE} from "../types/types";

export function setCurrentPage(state: any) {
    return {
        type: SET_CURRENT_MONITORING_PAGE,
        payload: state
    }
}

export function setCurrentPageSize(state: any) {
    return {
        type: SET_CURRENT_MONITORING_SIZE,
        payload: state
    }
}

export function setPageForFirst(state: any) {
    return {
        type: SET_FIRST_PAGE,
        payload: state
    }
}

export function getAudioUrlForPlayer(state: any) {
    return {
        type: GET_AUDIO_URL,
        payload: state
    }
}

export function setAudioUnavailable(unavailable: boolean) {
    return {
        type: SET_AUDIO_UNAVAILABLE,
        payload: unavailable,
    }
}

export function showExportLoader(state: boolean) {
    return {
        type: SHOW_EXPORT_LOADING,
        payload: state
    }
}

export function showLoader() {
    return {
        type: SHOW_LOADER,
    }
}

export function showMonitorQueueLoader(state: boolean) {
    return {
        type: SHOW_MONITORING_QUEUE_LOADER,
        payload: state
    }
}

export function hideLoader() {
    return {
        type: HIDE_LOADER,
    }
}

export function hideError() {
    return {
        type: HIDE_ERROR,
    }
}

export function addToMonitoringList(item: any) {
    return {
        type: ADD_TO_MONITORING_LIST,
        payload: item
    };
}

export function clearMonitoringSipDetails() {
    return {
        type: CLEAR_MONITORING_FOR_SIP,
    };
}

export function autoReloadToggle(reload: boolean) {
    return {
        type: MONITORING_RELOAD_TOGGLE,
        payload: reload
    };
}

export function updateSortFields(updatedFields: any) {
    return {
        type: UPDATE_SORT_FIELDS,
        payload: updatedFields,
    };
}

export function setMonitoringFilter(payload: any) {
    return {
        type: SET_MONITORING_FILTER,
        payload: payload,
    };
}

export function setIsSpeacking(payload: any) {
    return {
        type: SET_SPEAKING_AUDIO,
        payload: payload,
    };
}

export const updateMonitoringFilter = (field: string, value: any) => ({
    type: UPDATE_MONITORING_FILTER,
    payload: { field, value }
});

export const setMonitoringUiFilters = (filters: Record<string, any>) => ({
    type: SET_MONITORING_UI_FILTERS,
    payload: filters
});

export const getMonitoringQueue = (payload: any) => ({
    type: GET_MONITORING_QUEUE,
    payload: payload,
});

export const getNewMonitoringQueue = (payload: any) => ({
    type: GET_NEW_MONITORING_QUEUE,
    payload: payload,
});

export const removeFromMonitoringQueue = (sessionId: string) => ({
    type: REMOVE_FROM_MONITORING_QUEUE,
    payload: sessionId,
});

export function setCurrentMonitoringQueuePage(state: any) {
    return {
        type: SET_CURRENT_MONITORING_QUEUE_PAGE,
        payload: state
    }
}

export function setCurrentMonitoringQueuePageSize(state: any) {
    return {
        type: SET_CURRENT_MONITORING_QUEUE_SIZE,
        payload: state
    }
}

export function setQueueMonitorStats(stats: { countActiveCalls: number, withNotification: boolean }) {
    localStorage.setItem('queueMonitorStats', JSON.stringify(stats));

    updateTabIconAndTitle(stats);

    return {
        type: SET_QUEUE_MONITOR_STATS,
        payload: stats
    }
}

function updateTabIconAndTitle(stats: { countActiveCalls: number, withNotification: boolean }) {
    const originalTitle = document.title.replace(/^🔔\s*/, ''); // Убираем существующую иконку

    if (stats.withNotification && stats.countActiveCalls > 0) {
        document.title = `🔔 ${originalTitle}`;
    } else {
        document.title = originalTitle;
    }
}
